import { Component, Input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { AwButtonIconOnlyDirective } from '@assetworks-llc/aw-component-lib';

@Component({
  selector: 'app-unassign-button',
  standalone: true,
  imports: [MatIcon, AwButtonIconOnlyDirective],
  template: `
    <button
      AwButtonIconOnly
      buttonType="primary"
      [disable]="!isAssigned"
      (click)="handleClick()"
    >
      <mat-icon svgIcon="delete"></mat-icon>
    </button>
  `,
})
export class UnassignButtonComponent {
  @Input() isAssigned = false;
  @Input() rowData: any;
  @Input() onUnassign!: (row: any) => void;

  handleClick(): void {
    if (this.isAssigned && this.onUnassign) {
      this.onUnassign(this.rowData);
    }
  }
}
